import { render } from "./404.vue?vue&type=template&id=16ad2b16"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import exportComponent from "D:\\phpstudy_pro\\WWW\\tgl.liuxianfa.cn\\mobileNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__